import { Card, CardContent, CardHeader, CardTitle, QueryState } from "@nymbl/nos2-rules";
import { useKpis } from "@/hooks/use-month";
import { visibleKpis } from "@/lib/month/metrics";

/** Incentyv's scorecard lines for the year, shown as stored (never recomputed). Hidden when none. */
export function KpiPanel({ year }: { year: number }) {
  const kpis = useKpis(year);
  const cards = visibleKpis(kpis.data ?? []);
  if (kpis.isSuccess && cards.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <h2 className="font-display text-lg font-bold">My KPIs · {year}</h2>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <QueryState query={kpis} skeletonClassName="h-20">
          {() => (
            <div className="grid grid-cols-2 gap-4">
              {cards.map(({ card, shown }) => (
                <div key={card.id} className="flex min-w-0 flex-col gap-1">
                  <div className="text-sm font-semibold text-muted-foreground">{card.metric}</div>
                  <div className="font-display text-2xl font-bold break-words sm:text-3xl">
                    {shown.value}
                  </div>
                  {shown.projected && (
                    <div className="text-xs text-muted-foreground">projected</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </QueryState>
      </CardContent>
    </Card>
  );
}
